module.exports = __webpack_public_path__ + "img/QRCode_iphone13.b2f83763.png";